<template>
  <div>
    <card class="m-b">
      <i-form ref="form"
              :rules="rules"
              :model="form"
              :label-width="120">
        <FormItem :label="$t('pages_roles_permissions_914')"
                  prop="name">
          <i-input size="large"
                   v-model="form.name" />
        </FormItem>
        <!-- <FormItem label="角色类型"
                  prop="role_type">
          <i-select v-model="form.role_type">
            <i-option v-for="item in role_types"
                      :key="item.id"
                      :value="item.value">{{item.name}}</i-option>
          </i-select>
        </FormItem> -->
        <FormItem :label="$t('pages_roles_permissions_915')"
                  prop="permission_data">
          <div class="group">
            <div class="group-items">
              <div>
                <Checkbox :value="allChecked"
                          @on-change="changeAll" />{{$t('pages_roles_permissions_916')}}</div>
            </div>
          </div>
          <div class="group"
               v-for="item in permissionList"
               :key="item.id">
            <div class="group-name">
              <Checkbox :value="item.all_checked"
                        @on-change="changeGroupAll(item)" />
              {{ item.title }}
            </div>
            <div class="group-items">
              <div v-for="p in item.fresh_permission_items"
                   :key="p.name">
                <Checkbox v-model="form.permission_data[p.name]" /> {{ p.title }}
              </div>
            </div>
          </div>
        </FormItem>
        <FormItem>
          <i-button @click="submit"
                    type="primary">{{$t('pages_products_edit_831')}}</i-button>
        </FormItem>
      </i-form>
    </card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions } from 'vuex';
import { every, forEach } from 'lodash';

export default {
  name: 'RolePermissions',
  data () {
    return {
      form: {
        name: '',
        // role_type: 'staff',
        permission_data: {},
      },
      rules: {
        name: [
          { required: true, message: i18n.t('pages_roles_permissions_917') },
        ],
        // role_type: { required: true, message: '请选择角色类型' },
      },
      // role_types: [{
      //   id: 1,
      //   name: '员工',
      //   value: 'staff'
      // }, {
      //   id: 2,
      //   name: '推广公司',
      //   value: 'promote_company'
      // }]
    };
  },
  created () {
    this.fetchPermissionList({ page: 1, per: 65535 })
    const { id } = this.$route.params;
    if (id !== 'new') {
      this.show(id);
    } else {
      this.form = {
        name: '',
        // role_type: 'staff',
        permission_data: {},
      };
    }
  },
  computed: {
    ...mapState('role', ['role']),
    ...mapState('permission', ['permissions']),
    permissionList () {
      // console.info('---', this.permissions)
      return this.permissions.map(item => {
        const allChecked = every(item.fresh_permission_items, per => this.form.permission_data[per.name])
        // console.info('====', this.form.permission_data, allChecked)
        return {
          ...item,
          all_checked: allChecked,
        }
      });
    },
    allChecked () {
      return this.permissionList.every(i => i.all_checked)
    }
  },
  methods: {
    ...mapActions('role', ['show', 'create', 'update', 'destroy']),
    ...mapActions('permission', {
      fetchPermissionList: 'index',
    }),
    changeGroupAll (group) {
      forEach(group.fresh_permission_items, permission => {
        this.$set(this.form.permission_data, permission.name, !group.all_checked);
      });
    },
    changeAll () {
      const nextCheckStat = !this.allChecked;
      forEach(this.permissionList, group => {
        if (group.all_checked !== nextCheckStat) {
          this.changeGroupAll(group);
        }
      })
    },
    submit () {
      const vm = this;
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { id } = vm.$route.params;
          if (id !== 'new') {
            await this.update(this.form);
          } else {
            await this.create(this.form);
            if (this.role.id) {
              this.$router.replace(`/settings/user_roles`)
            }
          }
        }
      })
    }
  },
  watch: {
    role: {
      immediate: true,
      handler (value) {
        this.form = {
          ...value,
          permission_data: value.permission_data || {},
        };
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m-b {
  margin-bottom: 12px;
}

.group {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 24px 12px;
  margin-bottom: 20px;
  margin-top: 15px;
}

.group-name {
  margin-bottom: 20px;
  position: absolute;
  transform: translateY(-40px);
  background: #fff;
  margin-left: 20px;
  color: #999;
  padding: 0 5px;
}
.group-items {
  > div {
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 12px;
  }
}
</style>
